import axios from 'axios';
import * as rax from 'retry-axios';
import { storeItemToLog } from '../features/log/storeItemToLog';
import { v4 as uuidv4 } from 'uuid';

const { REACT_APP_BASE_URL: baseURL, REACT_APP_AUTH_TOKEN: authToken } = process.env;

const NTB_CUSTOMER_UUID = '1e0d4f2c-9a7d-4fc9-9b4f-44cc3163d7e1';

export const nifsAxios = axios.create({
  baseURL,
  headers: {
    Authorization: `Bearer ${authToken}`,
    accept: 'application/json',
    'customer-uuid': NTB_CUSTOMER_UUID,
  },
  data: {},
});

nifsAxios.defaults.raxConfig = {
  instance: nifsAxios,
  httpMethodsToRetry: ['GET', 'HEAD', 'OPTIONS', 'DELETE', 'PUT', 'POST', 'PATCH'],
  retry: 10,
  noResponseRetries: 10,
  retryDelay: 10000,
  onRetryAttempt: (err) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const matchIdString = urlParams.get('matchId') as string;
    if (matchIdString) {
      const requestId = err.config?.headers.get('X-Request-Id');
      if (!requestId) {
        storeItemToLog('Retry', err, parseInt(matchIdString), uuidv4());
      } else {
        storeItemToLog('Retry', err, parseInt(matchIdString), JSON.stringify(requestId, null, 4));
      }
    }
  },
};

rax.attach(nifsAxios);
